import React from 'react';
import styles from './TowerTokenIntro.module.scss';
import { useTranslation } from 'react-i18next';

import { HomeSectionTitle } from '../HomeSectionTitle/HomeSectionTitle';
import { Button } from 'react-bootstrap';

import StarPoint from '../../assets/imgs/home/img-star.png';

const renderStarPoints = (text) => {
    return (
        <div className={styles.reward_points}>
            <img src={StarPoint} alt="star-point" />
            <div>{text}</div>
        </div>
    )
}

const TowerTokenIntro = (props) => {
    const [t] = useTranslation();

    return (
        <div className={styles.tower_token_intro} id="tower_token_intro">
            <div className={styles.section_title}>
                <HomeSectionTitle
                    title={t('WHAT_IS_TOWER_TOKEN')}
                />
            </div>
            <div className={styles.section_body}>
                <div className={styles.info_section}>
                    <div className={styles.play_to_earn_section}>
                        <div className={`${styles.text_styles} ${styles.title_text}`}>{t('PLAY_TO_EARN')}</div>
                        <div className={styles.play_to_earn_info}>
                            <div>
                                {renderStarPoints(t('CDH_EVENTS'))}
                                {renderStarPoints(t('CK_EVENTS'))}
                            </div>
                            <div>
                                {renderStarPoints(t('LEADERBOARD_REWARDS'))}
                                {renderStarPoints(t('QUESTS'))}
                            </div>
                        </div>
                    </div>

                    <div className={styles.use_earned_tower}>
                        <div className={`${styles.text_styles} ${styles.options_text}`}>{t('EXCHANGE_CASH_OUT')}</div>
                        <div className={`${styles.text_styles} ${styles.options_text}`} style={{ marginTop: "14px" }}>{t('TOWER_CHEST')}</div>
                        <div className={`${styles.text_styles} ${styles.options_text}`}>{t('UPGRADES')}</div>
                    </div>
                </div>
                <a href="https://lightpaper.crazydefenseheroes.com/" target="_blank"><Button className={styles.light_paper_btn} variant='cdh-general-blue'>{t('LIGHT_PAPER')}</Button></a>
            </div>
        </div>
    )
}

export {TowerTokenIntro}
